import { SVGProps } from 'react'

export const CoachMode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.666748 9.08335L8.70194 13.1009C8.81126 13.1556 8.86592 13.1829 8.92325 13.1937C8.97403 13.2032 9.02614 13.2032 9.07691 13.1937C9.13425 13.1829 9.18891 13.1556 9.29822 13.1009L17.3334 9.08335M0.666748 4.91668L8.70194 0.899085C8.81126 0.844425 8.86592 0.817096 8.92325 0.806339C8.97403 0.796813 9.02614 0.796813 9.07691 0.806339C9.13425 0.817096 9.18891 0.844425 9.29822 0.899085L17.3334 4.91668L9.29822 8.93428C9.18891 8.98893 9.13425 9.01626 9.07691 9.02702C9.02614 9.03655 8.97403 9.03655 8.92325 9.02702C8.86592 9.01626 8.81126 8.98893 8.70194 8.93428L0.666748 4.91668Z"
      stroke="#0074DD"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
